var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-order-box"},[_c('div',{staticClass:"year-order-tool"}),_c('div',{staticClass:"year-order-charts",attrs:{"id":"yearCharts"}})])
}]

export { render, staticRenderFns }